import { render, staticRenderFns } from "./BlockchainSection.vue?vue&type=template&id=067ea128&scoped=true&"
import script from "./BlockchainSection.vue?vue&type=script&lang=js&"
export * from "./BlockchainSection.vue?vue&type=script&lang=js&"
import style0 from "./BlockchainSection.vue?vue&type=style&index=0&id=067ea128&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067ea128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VImg,VRow})
